import {
	WeaDialog
} from 'ecCom';
import {
	observer
} from 'mobx-react';
import AbsenceBrief from './AbsenceBrief';
import Type from './Type';
import Timeline from './Timeline';
import {
	Loading
} from '../../public/learn';

@observer
export default class Dialog extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		const {
			store
		} = this.props, {
			ABSENCEDIALOG,
			absenceDialog,
			absenceDetail,
			dialogHeight,
		} = store, {
			absenceDay,
			types,
			details,
		} = absenceDetail, {
			loading
		} = absenceDialog;

		let c;
		if (loading) {
			c = <Loading />
		} else {
			c = (
				<div className='absence'>
					<AbsenceBrief absenceDay={absenceDay}/>
					<Type types={types}/>
					<Timeline details={details} scrollY={dialogHeight}/>
				</div>
			)
		}
		return (
			<WeaDialog
				{...ABSENCEDIALOG}
				{...absenceDialog}
			>
				{c}
			</WeaDialog>
		);
	}
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrmAttendance/components/absenceDetail/Dialog.js